import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import { jsPDF } from "jspdf";
import { AppMainComponent } from "src/app/app.main.component";
import { ITermsConditions } from "src/app/configurations/inventory/orders/models/terms-conditions";
import { OrdersService } from "src/app/configurations/inventory/orders/orders.service";
import { SOChannel, CustomAttributeFieldType, PrintType, TaxCountry } from "../../constants/constants";
import { UtilityService } from "../../utils/utility.service";
import { RobotoFont } from "../../utils/vfs";
import { Observable, Subject, catchError, forkJoin, of, takeUntil } from "rxjs";
import { AppMainService } from "src/app/app-main.service";
import { InvoiceStatus } from "src/app/inventory/constants/constants";
import { ImportserialService } from "src/app/modules/shared/services/importserial.service";
import { TaxSplitService } from "src/app/modules/shared/components/products-tax-split-view/service/tax-split.service";

@Component({
    selector: "app-invoice-pdf",
    templateUrl: "./invoice-pdf.component.html",
    styleUrls: ["./invoice-pdf.component.scss"],
})
export class InvoicePdfComponent implements OnChanges {
    @Input() channel = "Invoicing";
    @Input() trackingOptions =[];
    @Input() objectName;
    @Input() detailsData: any;
    @Input() template: any;
    @Input() customFields: any;
    @Input() purchaseListTB = [];
    @Input() termsConditions: ITermsConditions;
    @Input() companyInfo;

    protected ngUnsubscribe$: Subject<void> = new Subject<void>();

    fieldTypes = CustomAttributeFieldType;
    productsSerialDetails = [];
    soChannel = SOChannel;
    billingAddress: any;
    shippingAddress: any;
    billingAddressContact: any;
    shippingAddressContact: any;
    docName = "";

    // barcode properties
    elementType = "img";
    format = "CODE128";
    lineColor = "#000000";
    width = 1;
    height = 20;
    displayValue = true;
    fontOptions = "";
    font = "monospace";
    textAlign = "center";
    textPosition = "bottom";
    textMargin = 5;
    fontSize = 14;
    background = "#ffffff";
    margin = 10;
    marginTop = 10;
    marginBottom = 10;
    marginLeft = 0;
    marginRight = 10;
    bundleLists: any[] = [];
    signature;
    imagePath: any;
    appLogoPath: any;
    symbol = "$";
    utilService:  UtilityService;
    invStatus = InvoiceStatus;
    totalAmount: number = 0;
    productsTotalAdditionalAmount: number = 0;
    
    showTaxBasedSplitView = false;
    isStateMatched = false;
    taxBasedProductsList = [];
    taxBasedProductsCols = [];

    // fraction digits
    fractionDigits: number = 0;
    qtyFractionDigits: number = 0;

    // currency
    savedCurrencyUnit: any;
    savedCurrencyExchangeRate: any = 1;
    baseCurrency: any;
    orgCurrency = [];


    constructor(
        private utilityService: UtilityService,
        public app: AppMainComponent,
        private ordersService: OrdersService,
        private appMainService: AppMainService,
        private importService: ImportserialService,
        private taxSplitService: TaxSplitService
    ) {
        this.utilService = this.utilityService;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.detailsData && changes.detailsData.currentValue) {
            this.detailsData = changes.detailsData.currentValue;
            this.setAddressData();
            this.calculateTotalAmount();
        }
        if (changes.purchaseListTB && changes.purchaseListTB.currentValue) {
            this.purchaseListTB = changes.purchaseListTB.currentValue;
            this.getBundleLength();
            this.getProductSerialDetails();
        }
        if (changes.objectName && changes.objectName.currentValue) {
            this.objectName = changes.objectName.currentValue;
        }
    }

    ngOnInit(): void {
        this.getFractionDigits();
        this.getQtyDecimalDigits();
        this.getBaseCurrency();
    }
    getFractionDigits() {
        this.importService
            .getDecimalValue()
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: (value) => {
                    if(value){
                        this.fractionDigits = value;
                    }
                },
                error: (error) => {},
            });
    }
    getQtyDecimalDigits() {
        this.importService.getQtyDecimalValue().subscribe(value => {
           if (value) {
             this.qtyFractionDigits = value;
           }
         })
    }

    getBaseCurrency() {
        this.importService
            .getOrgCurrency()
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe((value) => {
                if (value) {
                    this.baseCurrency = value.find((cr) => cr.isBaseCurrency);
                    this.orgCurrency = value;
                }
            });
    }
    setAddressData() {
        this.savedCurrencyUnit = this.detailsData.account?.currencyUnit;
        this.savedCurrencyExchangeRate = Number(this.detailsData.exchangeRate ?? 1);
        this.billingAddress = this.detailsData.account.accountAddresses.filter((d) => d.addressId == this.detailsData.billingAddressId)[0];
        this.shippingAddress = this.detailsData.account.accountAddresses.filter((d) => d.addressId == this.detailsData.shippingAddressId)[0];
        this.billingAddressContact = this.detailsData?.contact;
        this.shippingAddressContact = this.detailsData?.shipContact;
        this.checkCountryToShowSplitView();
    }
    checkCountryToShowSplitView() {
        if (this.shippingAddress?.address?.countryId == TaxCountry.India) {
            if(this.shippingAddress?.address?.countryId == this.detailsData?.warehouse?.address?.countryId && this.shippingAddress?.address?.state?.name?.toLowerCase() == this.detailsData?.warehouse?.address?.state?.name?.toLowerCase()){
                this.isStateMatched = true;
            } else {
                this.isStateMatched = false;
            }
            this.showTaxBasedSplitView = true;
        } else {
            this.showTaxBasedSplitView = false;
        }

        if(this.showTaxBasedSplitView){
            const taxSplitObj = this.taxSplitService.prepareTaxBasedProductsList(this.purchaseListTB, this.channel, this.isStateMatched);
            this.taxBasedProductsCols = taxSplitObj?.taxBasedProductsCols;
            this.taxBasedProductsList = taxSplitObj?.taxBasedProductsList;
        }
    }
    calculateTotalAmount(){
        this.totalAmount = this.detailsData?.invoiceProducts?.reduce((total, item) => total + Number(item?.totalAmount), 0);
        this.productsTotalAdditionalAmount = this.calculateInvoiceProductsTotalAdditionalAmount();
    }
    calculateInvoiceProductsTotalAdditionalAmount() {
        const getAdditionalAmount = (item) => {
            let total = item?.product?.typeId == 4 ? 0 : Number(item?.additionalAmount) || 0;
            if (item?.invoiceBundleDetail && item.invoiceBundleDetail?.length > 0) {
                total += item.invoiceBundleDetail.reduce((sum, bundleItem) => {
                    return sum + getAdditionalAmount(bundleItem);
                }, 0);
            }
            return total;
        };
    
        const productsTotalAdditionalAmount = this.detailsData?.invoiceProducts?.reduce((total, item) => {
            return total + getAdditionalAmount(item);
        }, 0) || 0;

        return productsTotalAdditionalAmount;
    }

    getBundleLength() {
        let arr: any[] = [];
        for (let product of this.purchaseListTB) {
            if (this.channel == this.soChannel.ESTIMATES) {
                for (let s of product?.estimateBundleDetail) {
                    arr.push(s);
                }
            } else if (this.channel == this.soChannel.SALES_ORDER) {
                for (let s of product?.salesOrderBundleDetail) {
                    arr.push(s);
                }
            } else if (this.channel == this.soChannel.INVOICING) {
                for (let s of product?.invoiceBundleDetail) {
                    arr.push(s);
                }
            } else if (this.channel == this.soChannel.CREDIT_MEMO) {
                for (let s of product?.creditMemoBundleDetail) {
                    arr.push(s);
                }
            }
        }
        this.bundleLists = JSON.parse(JSON.stringify(arr));
    }

    getOrganizationLogo() {
        return this.getBase64ImageFromUrl(this.app.appLogo)
            .then((response: string) => {
                let res: string = response;
                return res.replace("data:application/octet-stream", "data:image/png");
            })
            .catch((error) => {
                return null;
            });
    }
    
    async getBase64ImageFromUrl(imageUrl) {
        var res = await fetch(imageUrl);
        var blob = await res.blob();
        return new Promise((resolve, reject) => {
            var reader = new FileReader();
            reader.addEventListener(
                "load",
                function () {
                    resolve(reader.result);
                },
                false,
            );
            reader.onerror = () => {
                return reject(this);
            };
            reader.readAsDataURL(blob);
        });
    }

    print(type = PrintType.PRINT) {
        this.appMainService.isShowSpinner("printpdf");
        forkJoin([
            this.getOrganizationLogo(),
            this.ordersService.getSignatureByObjectName(this.objectName).pipe(
                catchError((error) => {
                    return of(null);
                }),
            ),
        ]).subscribe(([logoResponse, signatureResponse]) => {
            this.appLogoPath = logoResponse; // org logo
            this.signature = signatureResponse; // signature
            if (this.signature) {
                this.getBase64ImageFromUrl(signatureResponse?.attachmentImage?.downloadLink).then((response: string) => {
                    let res: string = response;
                    this.imagePath = res.replace("data:application/octet-stream", "data:image/png");
                });
            }
            setTimeout(() => {
                this.appMainService.isHideSpinner("printpdf");
                this.processPrint(type);
            }, 1000);
        });
    }

    processPrint(type = PrintType.PRINT) {
        let pdf = new jsPDF("p", "pt", "a4", true);
        pdf.addFileToVFS("Roboto-Regular.ttf", RobotoFont);
        pdf.addFont("Roboto-Regular.ttf", "Roboto-Regular", "normal");
        pdf.setFont("Roboto-Regular");

        let html = document?.getElementById("invoicePreview").innerHTML;
        html = html.replace(/width="100%"/, 'width="555"');
        let pdfFileName = "Invoice_" + this.detailsData?.number;
        pdf.setProperties({ title: pdfFileName + ".pdf" });
        pdf.html(html, {
            margin: [30, 15],
            callback: (generatedPdf) => {
                // pdf.output("dataurlnewwindow");
                const dataUri = generatedPdf.output("datauristring");
                const newTab = window.open();
                newTab?.document?.write('<iframe width="100%" height="100%" src="' + dataUri + '" type="application/pdf"></iframe>');
                if(newTab && newTab.document){
                    newTab.document.title = pdfFileName + ".pdf";
                }
            },
        });
    }

    getProductSerialDetails() {
        this.productsSerialDetails = [];
        this.productsSerialDetails = this.utilityService.getInvoiceProductsSerialDetails(this.purchaseListTB);
    }

    downloadAsPdf(type = PrintType.PRINT) {
        this.appMainService.isShowSpinner("printpdf");
        forkJoin([
            this.getOrganizationLogo(),
            this.ordersService.getSignatureByObjectName(this.objectName).pipe(
                catchError((error) => {
                    return of(null);
                }),
            ),
        ]).subscribe(([logoResponse, signatureResponse]) => {
            this.appLogoPath = logoResponse; // org logo
            this.signature = signatureResponse; // signature
            if (this.signature) {
                this.getBase64ImageFromUrl(signatureResponse?.attachmentImage?.downloadLink).then((response: string) => {
                    let res: string = response;
                    this.imagePath = res.replace("data:application/octet-stream", "data:image/png");
                });
            }
            setTimeout(() => {
                this.appMainService.isHideSpinner("printpdf");
                this.processDownloadAsPdf(type);
            }, 1000);
        });
    }

    processDownloadAsPdf(type = PrintType.PRINT) {
        let pdf = new jsPDF("p", "pt", "a4", true);
        pdf.addFileToVFS("Roboto-Regular.ttf", RobotoFont);
        pdf.addFont("Roboto-Regular.ttf", "Roboto-Regular", "normal");
        pdf.setFont("Roboto-Regular");

        let html = document?.getElementById("invoicePreview").innerHTML;
        html = html.replace(/width="100%"/, 'width="555"'); //Change the table width for fitting in pdf page
        pdf.html(html, {
            callback: function (pdf) {
                pdf.save("invoice.pdf");
            },
            margin: [30, 15],
        });
    }

    getPdf(type = PrintType.PRINT): Observable<any> {
        return Observable.create((observer) => {
            this.appMainService.isShowSpinner("printpdf");
            forkJoin([
                this.getOrganizationLogo(),
                this.ordersService.getSignatureByObjectName(this.objectName).pipe(
                    catchError((error) => {
                        return of(null);
                    }),
                ),
            ]).subscribe(([logoResponse, signatureResponse]) => {
                this.appLogoPath = logoResponse; // org logo
                this.signature = signatureResponse; // signature
                if (this.signature) {
                    this.getBase64ImageFromUrl(signatureResponse?.attachmentImage?.downloadLink).then((response: string) => {
                        let res: string = response;
                        this.imagePath = res.replace("data:application/octet-stream", "data:image/png");
                    });
                }
                setTimeout(() => {
                    this.appMainService.isHideSpinner("printpdf");
                    const pdf = new jsPDF("p", "pt", "a4", true);
                    pdf.addFileToVFS("Roboto-Regular.ttf", RobotoFont);
                    pdf.addFont("Roboto-Regular.ttf", "Roboto-Regular", "normal");
                    pdf.setFont("Roboto-Regular");
                    let html = document?.getElementById("invoicePreview").innerHTML;
                    html = html.replace(/width="100%"/, 'width="555"');
                    pdf.html(html, {
                        margin: [30, 15],
                        callback: (pdfOutput) => {
                            observer.next(pdfOutput);
                            observer.complete();
                        },
                    });
                }, 1000);
            });
        });
    }

    replaceCommaLine(data) {
        if (data) {
            let dataToArray = data.split(",").map((item) => item.trim());
            return dataToArray;
        }
    }
}
